/**
 */

define('directives/common/dynamic-grid/dynamicGrid.directives',['app','mainCons'], function (app,mainCons) {
    app.directive('dynamicGrid', ['UserInfo','auiDialog',function (UserInfo,auiDialog) {
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            templateUrl: 'directives/common/dynamic-grid/dynamicGrid.template.html',
            scope: {
            	gridColumns: "=",
                isInput: "=",
                gridRows: "=",
                addTag: "=",
                formName:"="
            },
            link: function ($scope, element, attrs) {
            	var queationnaireAddRelatedMaxNum = sysParamCfg.queationnaireAddRelatedMaxNum;
                function init(){
                	addIndexAttr();
                }
                init();
                
                function addIndexAttr(){
                	if($scope.gridRows && $scope.gridRows.length>0){
                		for(var i=0;i<$scope.gridRows.length;i++){
                			$scope.gridRows[i].index = i;
                		}
                	}
                }
                
                $scope.delRow = function(row){
                	for(var i = 0; i < $scope.gridRows.length; i++) {
                	    if($scope.gridRows[i].index == row.index) {
                	    	$scope.gridRows.splice(i, 1);
	                	     break;
                	    }
                	}
                };
                
                $scope.addRow = function(row){
                	if($scope.gridRows.length >= queationnaireAddRelatedMaxNum){
                		auiDialog.warn('最多可以填写'+queationnaireAddRelatedMaxNum+'条关联信息。');
                		return;
                	}
                	if($scope.gridRows.length == 0){
                		$scope.gridRows.push({index:0});
                	}else{
                		$scope.gridRows.push({index:$scope.gridRows[$scope.gridRows.length-1].index + 1});
                	}
                };
                
            }
        }
    }]);
});

